import { Component, Inject, ViewEncapsulation } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { fuseAnimations } from "@fuse/animations";
import { StatusMovimentacao } from "app/auxiliares/models/status-movimentacao.model";
import { StatusMovimentacaoService } from "app/auxiliares/services/status-movimentacao.service";
import { BaseComponent, LoadingTeste } from "app/base-module/base-component/base.component";
import { AuthService } from "app/base-module/base-service/auth.service";
import { ClienteModel } from "app/clientes/models/cliente.model";
import { ClienteFundoInvestimentoService } from "app/clientes/services/cliente-fundo-investimento.service";
import { ClienteService } from "app/clientes/services/cliente.service";
import { map, Observable } from "rxjs";
import { FundoInvestimentoService } from "../services/fundo-investimento.service";

export interface DialogData {
    acao_comercial_id: any;
    cliente_id: any;
    id: any;
}

interface ICliente {
    id: number;
    nome: string;
    numero_xp: string;
}

interface IFundoInvestimento {
    id: number;
    nome: string;
}

@Component({
    selector: "app-cadastro-boleta-fundo",
    templateUrl: "./cadastro-boleta-fundo.component.html",
    styleUrls: ["./cadastro-boleta-fundo.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    providers: [FundoInvestimentoService],
})
export class CadastroBoletaFundoComponent extends BaseComponent {
    valor = new FormControl("", [Validators.required]);
    fundo = new FormControl<IFundoInvestimento | null>(null, [
        Validators.required,
    ]);
    cliente = new FormControl<ICliente | null>(null, [Validators.required]);
    cliente_id = new FormControl("", [Validators.required]);
    status_id = new FormControl();
    qtd = new FormControl();

    model: any = {
        caracteristica_id: "",
        acao_comercial_id: "",
    };

    loadingLocal: any;
    titulo!: string;
    texto!: string;
    listFundoInvestimento: any[] = [];
    listStatus: StatusMovimentacao[] = [];
    loadingSpinnerFundoInvestimento: boolean = false;
    loadingSpinnerStatus: boolean = false;
    loadingSpinner!: boolean;
    filteredOptions!: Observable<ClienteModel[]>;
    filteredOptionsFundo!: Observable<any[]>;

    constructor(
        public _boletaService: ClienteFundoInvestimentoService,
        private _serviceFundoInvestimento: FundoInvestimentoService,
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        private loading: MatDialog,
        public authService: AuthService,
        public dialogRef: MatDialogRef<CadastroBoletaFundoComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private _clienteService: ClienteService,
        private _statusService: StatusMovimentacaoService
    ) {
        super(dialog, snackBar);
        this.getAllStatus();

        if (this.data.id != null) {
            this.getBoleta();
        }

        this.cliente.valueChanges.subscribe((query) => {
            if (typeof query === "string" || typeof query === "number") {
                this.loadingSpinner = true;
                this.params.search = query;
                this.filteredOptions = this._clienteService.search(this.params).pipe(map((response) => response.data));
            }
        });

        this.fundo.valueChanges.subscribe((query) => {
            if (typeof query === "string" || typeof query === "number") {
                this.loadingSpinnerFundoInvestimento = true;
                this.params.search = query;
                this.filteredOptionsFundo =
                    this._serviceFundoInvestimento.search(this.params);
            }
        });
    }

    displayFn(cliente: any) {
        if (cliente) {
            return cliente.nome;
        }
    }

    displayFnFundo(fundo: any) {
        if (fundo) {
            return fundo.nome;
        }
    }

    getCliente(cliente: any) {
        this.loadingSpinner = false;
    }

    getFundo(cliente: any) {
        this.loadingSpinnerFundoInvestimento = false;
    }

    onNoClick(): void {
        this.dialogRef.close("cancel");
    }

    /**
     * Abre loagind
     */
    openLoadingLocal(): void {
        this.loadingLocal = this.loading.open(LoadingTeste, {
            width: "150px",
            disableClose: true,
        });
    }

    /**
     * Fecha loagind
     */
    closeLoadingLocal(): void {
        if (this.loadingLocal != null) {
            this.loadingLocal.close();
        }
    }

    isInvalidForm() {
        if (!this.valor.valid) {
            return true;
        }

        if (!this.status_id.valid) {
            return true;
        }

        if (!this.fundo.valid) {
            return true;
        }

        return false;
    }

    salvar() {
        this.openLoading();
        if (this.data.cliente_id != null) {
            this.model.cliente_id = this.data.cliente_id;
        } else {
            const novaBoletaCliente = this.cliente.value;
            this.model.cliente_id = novaBoletaCliente
                ? novaBoletaCliente.id
                : null;
        }

        const fundo = this.fundo.value;
        this.model.fundo_investimento_id = fundo ? fundo.id : null;
        this.model.valor = this.valor.value;
        this.model.status_id = this.status_id.value;
        this.model.qtd = this.qtd.value;

        if (this.data.id == null) {
            this._boletaService.create(this.model).subscribe(
                (data) => {
                    this.closeLoading();
                    this.dialogRef.close(data);
                },
                (error) => {
                    this.closeLoading();
                    this.showError(error.error.message);
                },
                () => {
                    console.log("complete");
                    this.closeLoading();
                }
            );
        } else {
            this._boletaService.update(this.data.id, this.model).subscribe(
                (data) => {
                    this.closeLoading();
                    this.dialogRef.close(data);
                },
                (error) => {
                    this.closeLoading();
                    this.showError(error.error.message);
                },
                () => {
                    console.log("complete");
                    this.closeLoading();
                }
            );
        }
    }

    getAllStatus() {
        this.loadingSpinnerStatus = true;

        this._statusService.getLista({ tipo_produto: "FU" }).subscribe(
            (list) => {
                this.listStatus = list.data ?? [];
            },
            (error) => { },
            () => {
                this.loadingSpinnerStatus = false;
                console.log("complete");
            }
        );
    }

    getErrorValorMessage() {
        return this.valor.hasError("required")
            ? "Valor é um campo obrigatório"
            : "";
    }

    getBoleta() {
        this.openLoading();
        this._boletaService.getById(this.data.id).subscribe(
            (boleta) => {
                this.valor.setValue(boleta.data.valor);
                this.fundo.setValue(boleta.data.fundo);
                this.cliente.setValue(boleta.data.cliente);
                this.cliente_id.setValue(boleta.data.cliente.id);
                this.status_id.setValue(boleta.data.status_id);
                this.qtd.setValue(boleta.data.qtd);
            },
            (error) => {
                this.closeLoading();
            },
            () => {
                this.closeLoading();
                console.log("complete");
            }
        );
    }
}
